import { useEffect, useState } from "react";
import {
  isSkillSyncInProgress,
  SKILL_SYNC_STALE_MS,
} from "../../shared/mutators/resyncSkill";

export function useSkillSyncInProgress(
  syncStartedAt: number | null | undefined
): boolean {
  const [, setStaleTick] = useState(0);

  useEffect(() => {
    if (syncStartedAt == null) return;
    const remaining = syncStartedAt + SKILL_SYNC_STALE_MS - Date.now();
    if (remaining <= 0) return;
    const timeout = window.setTimeout(
      () => setStaleTick((tick) => tick + 1),
      remaining
    );
    return () => window.clearTimeout(timeout);
  }, [syncStartedAt]);

  // oxlint-disable-next-line react/react-compiler -- blocks React Compiler; remove when fixed
  return isSkillSyncInProgress(syncStartedAt ?? null, Date.now());
}
